import { Environment } from 'environment.js'
import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { IOrder } from 'Model/index.js'
import { incompleteOrder } from 'View/Page/OrderManagementPage/IOrder.stub.js'

export const useGetOrderSelector = () => {
  return useSelector(getOrder)
}

const testOrder: IOrder = incompleteOrder

export const getOrder = (state: typeof State) => {
  return Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT === 'development' ? testOrder : state[orderSlice.name].order
}
